import React from 'react';

export default
<g>
  <path d="M0.8,12.4c0,0.9,0.7,1.6,1.5,1.6h6.2c0.9,0,1.5-0.7,1.5-1.6V3.1H0.8L0.8,12.4z M10.8,0.8H8.1L7.3,0H3.5
		L2.7,0.8H0v1.6h10.8L10.8,0.8z"/>
</g>
